module.exports = __webpack_public_path__ + "images/116_640.jpg";